import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customField", "selectionStep", "confirmationStep", "modal"]

  connect() {
    this.customFieldTarget.style.display = 'none'
  }

  hideCustom() {
    this.customFieldTarget.style.display = 'none'
    this.customFieldTarget.value = ''
  }

  showCustom() {
    this.customFieldTarget.style.display = 'block'
  }

  openLinkAndCloseModal(event) {
    const bootstrapModal = bootstrap.Modal.getInstance(this.modalTarget)
    if (bootstrapModal) {
      bootstrapModal.hide()
    }
  }

  showConfirmation(event) {
    event.preventDefault()
    
    const form = event.target.closest('form')
    const formData = new FormData(form)
    const selectedOption = formData.get('amount')
    let amount = selectedOption
    
    if (selectedOption === 'custom') {
      amount = formData.get('custom_amount')
      if (!amount || amount < 1000 || amount > 10000) {
        alert('Please enter a valid amount between $1,000 and $10,000')
        return
      }
    }

    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })
    const formattedAmount = formatter.format(amount)

    const confirmationMessage = this.confirmationStepTarget.querySelector('.confirmation-message')
    const paymentSource = this.confirmationStepTarget.dataset.paymentSource
    confirmationMessage.innerHTML = `Confirm the retainer refill payment of <strong>${formattedAmount}</strong> to be charged from <strong>${paymentSource}</strong>`

    this.selectionStepTarget.classList.add('d-none')
    this.confirmationStepTarget.classList.remove('d-none')
  }

  backToSelection() {
    this.confirmationStepTarget.classList.add('d-none')
    this.selectionStepTarget.classList.remove('d-none')
  }
}
